import { GraphQLNonNull, GraphQLList, GraphQLID } from 'graphql'
import { Context } from '../shared'
import { ContrastGraphQLFieldConfig } from '..'
import {
  vulnerabilityPolicyType,
  VulnerabilityPolicy,
  vulnerabilityPolicyAction,
  VulnerabilityPolicyAction
} from '../types/vulnerability-policy'
import { normalizeVulnerabilityPolicy } from './helpers/vulnerability'

interface VulnerabilityPoliciesQueryArgs {
  readonly organizationID: string
  readonly action: VulnerabilityPolicyAction
}

const vulnerabilityPoliciesQueryArgs = {
  organizationID: {
    description: 'The unique ID for the organization being queried',
    type: new GraphQLNonNull(GraphQLID)
  },
  action: {
    description: 'Vulnerability Policy type to filter by',
    type: new GraphQLNonNull(vulnerabilityPolicyAction)
  }
}

export const vulnerabilityPolicies: ContrastGraphQLFieldConfig<
  any,
  Context,
  VulnerabilityPoliciesQueryArgs,
  VulnerabilityPolicy[]
> = {
  description: 'Get vulnerability policies by organization ID and type',
  type: new GraphQLNonNull(
    new GraphQLList(new GraphQLNonNull(vulnerabilityPolicyType))
  ),
  args: vulnerabilityPoliciesQueryArgs,
  async resolve(_source, args, context) {
    const { organizationID, action } = args
    const { connector } = context
    const { policies = [] } = await connector.get(
      `/${organizationID}/policy/remediation?expand=skip_links&action=${action}`
    )
    return policies.map(normalizeVulnerabilityPolicy)
  }
}
